import './SeeDesigns.css';
let SeeDesigns=(props)=>{
    let desclickevent=()=>{
        alert("Please Fill Form To Print Your Resume/CV");
        
    }
    return(
        
        <div className='Seeonlydesigncont'>
            <h1>All Designes</h1>
            <hr></hr>
            { 
                props.linkdata.map( 
                    reclink=>(
                        <div className='imgcontlink'>
                            {/* <span className='SHOWMSG'>{}</span> */}
                            <img alt='Designes' onClick={desclickevent} className='imagechoose' src={reclink.Desimage}/> 
                        </div>  
                    )
                )
            }  
            <hr></hr>
        </div>
        
    );
}
export default SeeDesigns;